import { createAction } from 'redux-act';
/* Add Kudos Category action */
const addKudosCategoryRequest = createAction('ADD_KUDOS_CATEGORY_REQUEST', data => data);
const addKudosCategorySuccess = createAction('ADD_KUDOS_CATEGORY_SUCCESS', data => data);
const addKudosCategoryError = createAction('ADD_KUDOS_CATEGORY_ERROR');

/* Get Kudos Category action */
const getKudosCategoryRequest = createAction('GET_KUDOS_CATEGORY_REQUEST', data => data);
const getKudosCategorySuccess = createAction('GET_KUDOS_CATEGORY_SUCCESS', data => data);
const getKudosCategoryError = createAction('GET_KUDOS_CATEGORY_ERROR');

/* Create Kudos list */
const createKudosRequest = createAction('CREATE_KUDOS_REQUEST', data => data);
const createKudosSuccess = createAction('CREATE_KUDOS_SUCCESS', data => data);
const createKudosError = createAction('CREATE_KUDOS_ERROR');

/* Get Kudos Data action */
const getKudosDataRequest = createAction('GET_KUDOS_DATA_REQUEST', data => data);
const getKudosDataSuccess = createAction('GET_KUDOS_DATA_SUCCESS', data => data);
const getKudosDataError = createAction('GET_KUDOS_DATA_ERROR');

/* Add Kudos Point History action */
const addKudosPointHistoryRequest = createAction('ADD_KUDOS_POINT_HISTORY_REQUEST', data => data);
const addKudosPointHistorySuccess = createAction('ADD_KUDOS_POINT_HISTORY_SUCCESS', data => data);
const addKudosPointHistoryError = createAction('ADD_KUDOS_POINT_HISTORY_ERROR');

/* Get Point Statement action */
const getPointStatementRequest = createAction('GET_POINT_STATEMENT_REQUEST', data => data);
const getPointStatementSuccess = createAction('GET_POINT_STATEMENT_SUCCESS', data => data);
const getPointStatementError = createAction('GET_POINT_STATEMENT_ERROR');

/* Get Point Statement action */
const getUserKudosOnTypeRequest = createAction('GET_USER_KUDOS_ON_TYPE_REQUEST', data => data);
const getUserKudosOnTypeSuccess = createAction('GET_USER_KUDOS_ON_TYPE_SUCCESS', data => data);
const getUserKudosOnTypeError = createAction('GET_USER_KUDOS_ON_TYPE_ERROR');

/* Get Point Statement action */
const approveRejectKudosRequest = createAction('APPROVE_REJECT_KUDOS_REQUEST', data => data);
const approveRejectKudosSuccess = createAction('APPROVE_REJECT_KUDOS_SUCCESS', data => data);
const approveRejectKudosError = createAction('APPROVE_REJECT_KUDOS_ERROR');

/* clear existing Kudos action */
const handleClearKudosStore = createAction('HANDLE_CLEAR_KUDOS_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addKudosCategoryRequest,
    addKudosCategorySuccess,
    addKudosCategoryError,

    getKudosCategoryRequest,
    getKudosCategorySuccess,
    getKudosCategoryError,

    createKudosRequest,
    createKudosSuccess,
    createKudosError,

    getKudosDataRequest,
    getKudosDataSuccess,
    getKudosDataError,

    addKudosPointHistoryRequest,
    addKudosPointHistorySuccess,
    addKudosPointHistoryError,

    getPointStatementRequest,
    getPointStatementSuccess,
    getPointStatementError,

    getUserKudosOnTypeRequest,
    getUserKudosOnTypeSuccess,
    getUserKudosOnTypeError,
    
    approveRejectKudosRequest,
    approveRejectKudosSuccess,
    approveRejectKudosError,
    
    handleClearKudosStore,
    
}